export enum ServiceRequestStatus {
  PENDING_APPROVAL = "Pending Approval",
  APPROVED = "Approved",
  DECLINED = "Declined",
  IN_PROGRESS = "In Progress",
  AWAITING_PARTS = "Awaiting Parts",
  AWAITING_MORE_INFORMATION = "Awaiting More Information",
  COMPLETED = "Completed"
}

export interface IServiceRequestIssue {
  issueType: string;
  description: string;
  images?: string[];
}

export interface IServiceRequestAdditionalDetail {
  questionId?: string;
  question: string;
  answer?: string;
  answerType?: string;
  options?: string[];
  selectedOptions?: string[];
  files?: string[];
  isMandatory?: boolean;
}

export interface IServiceRequestJobSheetItem {
  task: string;
  taskDescription?: string;
  imageUrl?: string;
  cost: number;
}

export interface IServiceRequestNote {
  note: string;
  createdBy: string;
  createdByName?: string;
  createdAt: string;
  isCustomerVisible: boolean;
}

export interface IServiceRequestVehicleService {
  id?: string;
  referenceNumber?: string;
  status?: string;
  serviceType?: string;
  serviceCategory?: string;
  appointmentDate?: string;
  startDate?: string;
  endDate?: string;
  completionDate?: string;
  serviceProviderName?: string;
  serviceProviderAddress?: {
    street?: string;
    city?: string;
    fullAddress?: string;
    state?: string;
    country?: string;
    zipcode?: string;
  };
  description?: string;
  totalExpenses?: number;
  odometerReading?: number;
  jobSheet?: Array<{
    id?: string;
    name?: string;
    description?: string;
    cost?: number;
  }>;
  jobSheetStatus?: string;
}

export interface IServiceRequest {
  id: string;
  referenceNumber: string;
  vehicleId?: string;
  vehicle?: { id?: string; licencePlate?: string };
  serviceType?: string;
  serviceCategory?: string;
  issues: IServiceRequestIssue[];
  comments?: string;
  additionalDetails?: IServiceRequestAdditionalDetail[];
  customer?: {
    id: string;
  };
  businessCustomer?: {
    id: string;
  };
  status: ServiceRequestStatus;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy?: string;
  tenantId: string;
  organisationId: string;
  branchId: string;
  reviewedBy?: string;
  reviewedAt?: string;
  declineReason?: string;
  serviceProviderId?: string;
  serviceProviderName?: string;
  serviceProviderAddress?: any;
  appointmentDate?: string;
  estimatedCompletionDate?: string;
  estimatedCost?: number;
  actualCost?: number;
  jobSheet?: IServiceRequestJobSheetItem[];
  damages?: string[];
  notes?: IServiceRequestNote[];
  createdVehicleServiceId?: string;
  createdVehicleServiceRef?: string;
  vehicleService?: IServiceRequestVehicleService;
}









